export enum IM_FLAGS {
  CTV_TOGGLE = 'CTV_TOGGLE',
  FF_WELCOME = 'FF_WELCOME',
  CONNECT_TAG = 'CONNECT_TAG',
  FF_IM_EXTRA_SOCIAL_FIELDS = 'FF_IM_EXTRA_SOCIAL_FIELDS',
  FF_IM_DISABLE_USAGE = 'FF_IM_DISABLE_USAGE'
}
